import type { IResource } from "../../interfaces/resource";
import { mapResources } from "./resourceMapper";
import { normalizeResource } from "./normalizeResource";

/**
 * Maps and logs already-fetched/enriched resources for AIEmpower context.
 */
export function logAIEmpowerMappedResources(resources: IResource[]) {
  const normalized = (resources ?? []).map(normalizeResource);
  const mapped = mapResources(normalized);
  return mapped;
}
